import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import { createRESTContract } from '../../index';
import { DashboardSchema } from './dashboard.schema';

export const dashboardContract = createRESTContract({
  getDashboard: {
    method: 'GET',
    path: '/dashboard',
    permissions: [PERMISSIONS.DASHBOARD.DASHBOARD_VIEW],
    response: DashboardSchema,
  },
});
